import type { LookupReference } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

function getMatchClassesRefData(): Promise<LookupReference[]> {
  return requestApiJsonOrThrow<LookupReference[]>('admin/reference-data/match-classes')
}

export const matchClassesRefDataQuery = {
  queryKey: ['match-classes-ref-data'],
  queryFn: () => getMatchClassesRefData(),
}
